// extracted by mini-css-extract-plugin
export default {"container":"TilesContainer_container__z4FiV"};